export const fetchUserState = async (userId) => {
    const response = await fetch(process.env.REACT_APP_FETCH_USER_STATE_URL, {
      method: "POST",
      body: JSON.stringify({ userId }),
      headers: {
        "content-type": "application/json",
      },
    });
  
    return response.json();
  };
  